import OSprite from "../sprites/OSprite";
import Omy from "../../Omy";
import OMath from "../../utils/OMath";

export default class OButtonMod extends OSprite {
    constructor(parent, conf) {
        super(conf["out"], conf["atlas"]);

        this._parent = parent;
        this._gdConf = conf;

        this._outTexture = this._gdConf["out"];
        this._overTexture = this._gdConf["over"];
        this._downTexture = this._gdConf["down"];
        this._blockrTexture = this._gdConf["block"];
        this._label = null;
        this._hintLabel = null;

        this._currentTexture = this._outTexture;

        this._isBlock = false;
        this._inDown = false;
        this._inButton = false;

        this._oneClick = false;

        //region Configure button
        this.name = this._gdConf["name"] || this.name;
        this.setXY(this._gdConf["x"] || 0, this._gdConf["y"] || 0);
        this.rotation = OMath.toRadians(this._gdConf["rotate"]) || 0;
        this.alpha = this._gdConf["alpha"] || 1;
        if (this._gdConf["scale"]) {
            this.setScale(this._gdConf["scale"], this._gdConf["scale"]);
        } else {
            if (this._gdConf["scaleX"]) {
                this.scaleX = this._gdConf["scaleX"] || 1;
            } else if (this._gdConf["scaleY"]) {
                this.scaleY = this._gdConf["scaleY"] || 1;
            }
        }

        let confHintAreaRect = this._gdConf["hintAreaRect"];
        confHintAreaRect && Omy.add.hintArea(this, confHintAreaRect, confHintAreaRect["type"], confHintAreaRect["debug"]);
        if (this._gdConf["label"])
            this._label = Omy.add.textJson(this, this._gdConf["label"]);
        if (this._gdConf["hintLabel"]) {
            this._hintLabel = Omy.add.textJson(this, this._gdConf["hintLabel"]);
            this._hintLabel.visible = false;
        }
        if (this._gdConf["oneClick"])
            this.oneClick = this._gdConf["oneClick"];
        this._parent && this._parent.addChild(this);
        if (this._gdConf["debug"])
            Omy.add.timer(0.1, Omy.add.regDebugMode, this, 0, false, true, 0, [this]);

        //endregion

        this.input = true;
        this.buttonMode = true;

        if (!Omy.isRealDesktop) {
            this.buttonMode = false;
            this.removeListener("pointerover", this._over, this);
            this.removeListener("pointerout", this._out, this);
        }

        this._btnGameState = 0;
        this._activeStateList = [];
        this._noActiveStateList = [];

        this.alwaysAvailable = false;

        this._btnManager = Omy.navigateBtn;
        this._btnManager.addBtn(this, this._updateState, this._updateBlocking);
    }

    revive() {
        super.revive();
        this._inDown = false;
        this._isBlock = false;
        this._inButton = false;
        this._currentTexture = this._outTexture;

        this._updateBtnGraphic();
        return this;
    }

    kill() {
        this._isBlock = true;

        return super.kill();
    }

    destroy(options) {
        if (this._label) {
            this.removeChild(this._label);
            this._label.destroy(true);
            this._label = null;
        }
        this._hintLabel && this._hintLabel.destroy(true);
        this._hintLabel = null;

        this._outTexture = null;
        this._overTexture = null;
        this._downTexture = null;
        this._blockrTexture = null;
        this._currentTexture = null;

        this._btnManager.removeBtn(this, this._updateState, this._updateBlocking);
        this._btnManager = null;
        this._activeStateList.length = 0;
        this._noActiveStateList = null;

        return super.destroy(options);
    }

//---------------------------------------
// PROTECTED
//---------------------------------------

    /** protected */
    setActiveStates(...args) {
        for (let i = 0; i < args.length; i++) {
            this._activeStateList.push(args[i]);
        }
    }

    /** protected */
    setNoActiveStates(...args) {
        for (let i = 0; i < args.length; i++) {
            this._noActiveStateList.push(args[i]);
        }
    }

    /** protected */
    changeTextures(outFrame, overFrame = null, downFrame = null, blockFrame = null) {
        this._outTexture = outFrame;
        this._overTexture = overFrame;
        this._downTexture = downFrame;
        this._blockrTexture = blockFrame;
        this._currentTexture = outFrame;

        this._updateBtnGraphic();
    }

    /** protected */
    checkState() {
        if (this._activeStateList.indexOf(this._btnGameState) !== -1) {
            this.onActive();
        } else if (this._noActiveStateList.indexOf(this._btnGameState) !== -1) {
            this.onBlock();
        } else if (this.alwaysAvailable) {
            this.onActive();
        } else {
            this.onHide();
        }
    }

    /** protected */
    onActive() {
        this.isBlock = false;
        this.visible = true;
    }

    /** protected */
    onBlock() {
        this.isBlock = true;
        this.visible = true;
    }

    /** protected */
    onHide() {
        this.visible = false;
    }

    /** protected */
    onKeyHandler() {
        this._inDown = true;
        this._up();
    }

    /** protected */
    onDoAction() {

    }

//---------------------------------------
// PRIVATE
//---------------------------------------

    _updateState(state) {
        this._btnGameState = state;
        this.checkState();
    }

    _updateBlocking(value) {
        if (value ||
            (!value && this._activeStateList.indexOf(this._btnGameState) !== -1) ||
            (!value && this.alwaysAvailable && this._noActiveStateList.indexOf(this._btnGameState) === -1)) {
            if (!value) {
                this.onActive();
            } else {
                this.isBlock = true;
            }
        }
    }

    _updateBtnGraphic() {
        if (this.texture !== this._currentTexture)
            this.texture = this._currentTexture;
    }

    _onDownHandler() {

    }

    _onOverHandler() {
        if (this._hintLabel) {
            if (this.parent) this.parent.addChild(this._hintLabel);
            this._hintLabel.visible = true;
        }
    }

    _onOutHandler() {
        if (this._hintLabel) {
            if (this.parent) this.parent.removeChild(this._hintLabel);
            this._hintLabel.visible = false;
        }
    }

    _onUpHandler() {

    }

    _down() {
        if (this._isBlock) return;
        if (this._downTexture) {
            this._currentTexture = this._downTexture;
            this._updateBtnGraphic();
        }
        if (this._label && this._label.json["down"])
            this._label.setColor(this._label.json["down"]);
        this._inDown = true;
        this._onDownHandler();
        super._down();
    }

    _over() {
        this._inButton = true;
        if (this._isBlock) return;
        if (this._inDown) return;
        if (this._overTexture) {
            this._currentTexture = this._overTexture;
            this._updateBtnGraphic();
        }
        if (this._label && this._label.json["over"])
            this._label.setColor(this._label.json["over"]);
        this._onOverHandler();
        super._over();
    }

    _out() {
        this._inButton = false;
        if (this._isBlock) return;
        if (this._inDown) return;
        if (this._outTexture) {
            this._currentTexture = this._outTexture;
            this._updateBtnGraphic();
        }
        if (this._label && this._label.json["fill"])
            this._label.setColor(this._label.json["fill"]);
        this._onOutHandler();
        super._out();
    }

    _upOutSide() {
        this._inDown = false;
        super._upOutSide();
    }

    _up() {
        if (this._isBlock) return;
        if (this._overTexture && this._inButton)
            this._currentTexture = this._overTexture;
        else
            this._currentTexture = this._outTexture;
        if (this._label && this._label.json["fill"])
            this._label.setColor(this._label.json["fill"]);
        this._updateBtnGraphic();
        if (!this._inDown) return;
        this._inDown = false;
        this._onUpHandler();
        this.onDoAction();
        super._up();
        if (this._oneClick)
            this.isBlock = true;
    }

//---------------------------------------
/// ACCESSOR
//--------------------------------------

    set labelText(value) {
        this._label && (this._label.text = value);
    }

    get labelText() {
        return this._label ? this._label.text : "";
    }

    set hintLabelText(value) {
        this._hintLabel && (this._hintLabel.text = value);
    }

    get hintLabelText() {
        return this._hintLabel ? this._hintLabel.text : "";
    }

    get isBlock() {
        return this._isBlock;
    }

    set isBlock(value) {
        if (this._isBlock && value || !this._isBlock && !value) return;
        if (value) {
            if (this._hintLabel) {
                if (this.parent) this.parent.removeChild(this._hintLabel);
                this._hintLabel.visible = false;
            }
            if (this._blockrTexture) {
                this._currentTexture = this._blockrTexture;
            } else {
                this._currentTexture = this._outTexture;
            }
        } else {
            this._currentTexture = this._outTexture;
        }
        this._updateBtnGraphic();

        if (this._label)
            if (value && this._label.json["block"])
                this._label.setColor(this._label.json["block"]);
            else if (!value && this._label.json["fill"])
                this._label.setColor(this._label.json["fill"]);
        this._isBlock = value;
        this.input = !value;
        this.buttonMode = !value;
    }

    set oneClick(value) {
        this._oneClick = value;
    }
}
